// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const ProductStatus = {
  Active: {
    Name: 'Active',
    Value: 'active',
    Icon: 'CheckCircle',
  },
  Draft: {
    Name: 'Draft',
    Value: 'draft',
    Icon: 'Edit',
  },
  Archived: {
    Name: 'Archived',
    Value: 'archived',
    Icon: 'Archive',
  },
} as const

export type ProductStatusValue = (typeof ProductStatus)[keyof typeof ProductStatus]['Value']
